// Recidiviz - a data platform for criminal justice reform
// Copyright (C) 2024 Recidiviz, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.
// =============================================================================

import { OpportunityTableColumnId } from "../../../../../../core/OpportunityCaseloadView/HydratedOpportunityPersonList";
import { OpportunityTab } from "../../../../types";
import { ApiOpportunityConfiguration } from "../../ApiOpportunityConfigurationImpl";

export class UsAzReleaseToTPRConfiguration extends ApiOpportunityConfiguration {
  eligibilityDateTextForTab(tab?: OpportunityTab): string | undefined {
    if (tab && ["Fast Trackers", "Eligible Now", "Overdue"].includes(tab)) {
      return "TPR Date";
    } else {
      return "TPR or Projected TPR";
    }
  }

  get enableWorkflowsFilter(): boolean {
    return true;
  }

  get enabledColumns(): Array<OpportunityTableColumnId> {
    const cols = [...super.enabledColumns];
    const colsToAdd: OpportunityTableColumnId[] = [
      "AGREEMENT_STATUS",
      "HOME_PLAN_STATUS",
      "MAN_LIT_STATUS",
    ].filter(
      (c) => !cols.includes(c as OpportunityTableColumnId),
    ) as OpportunityTableColumnId[];
    const colsToRemove: OpportunityTableColumnId[] = ["STATUS"];
    return [...cols, ...colsToAdd].filter((c) => !colsToRemove.includes(c));
  }
}
